
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/1000W-PRO-LED",
      function () {
        return require("private-next-pages/product/1000W-PRO-LED.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product/1000W-PRO-LED"])
      });
    }
  